export default __webpack_public_path__ + "8fc53f0946f39db49570a1f93f47e0c3.png";